import type { ReactNode } from 'react';

import Modal from '../../Modal/index';
import FormikForm from '../Form/FormikForm';

import type { FormModalProps } from '@/types/formTypes';

const FormModal = ({
  title,
  fields,
  initialValues,
  validationSchema = null,
  onSubmit,
  onCancel,
  submitLabel,
  error = null,
  formErrorName,
  width,
  height,
}: FormModalProps): ReactNode => {
  return (
    <Modal
      title={title}
      hideActions
      onClose={() => {
        onCancel();
      }}
      error={error}
      width={width ?? ''}
      {...(height && {
        height,
      })}
    >
      <FormikForm
        fields={fields}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        onCancel={onCancel}
        submitLabel={submitLabel}
        formErrorName={formErrorName}
      />
    </Modal>
  );
};

export default FormModal;
